import React from 'react';
import LAppOnline from '../../../app/layouts/LAppOnline';
import { globalConfig } from '../../../app/config/config';

const PTestConfig = () => {
	return <LAppOnline>TEST Config {globalConfig.get().test_var}</LAppOnline>;
};

export default PTestConfig;
